import Link from 'next/link';
import { FeedAuthor } from '@/platform/feed/FeedAuthor';
import { ClaimBadges, type CommunityValidity } from '@/domains/paydirt/ClaimBadges';

export type FeedCardProps = {
  id: string;
  title: string;
  userId?: string;
  roiPct?: number;
  createdAt?: string;
  href?: string;
  subtitle?: string;
  body?: string;
  imageUrl?: string;
  communityApproved?: boolean;
  communityValidity?: CommunityValidity;
  hasVideo?: boolean;
};

export function FeedCard({
  id,
  title,
  userId,
  roiPct,
  createdAt,
  href,
  subtitle,
  body,
  imageUrl,
  communityApproved,
  communityValidity,
  hasVideo,
}: FeedCardProps) {
  const link = href ?? `/claims/${id}/`;
  const roiLabel = roiPct != null ? `ROI ${roiPct.toFixed(1)}%` : undefined;

  return (
    <article className="feed-card feed-card--social">
      {userId && <FeedAuthor userId={userId} createdAt={createdAt} meta="Haul report" />}
      <div className="feed-card__body">
        <h3 className="feed-card__title">
          <Link href={link}>{title}</Link>
        </h3>
        {body && <p className="feed-card__excerpt">{body}</p>}
        {subtitle && !body && <p className="feed-card__excerpt text-muted">{subtitle}</p>}
      </div>
      {imageUrl ? (
        <Link href={link} className="feed-card__media">
          <div
            className="feed-card__placeholder feed-card__placeholder--photo"
            style={{ backgroundImage: `url('${imageUrl}')` }}
            aria-hidden
          />
        </Link>
      ) : (
        <Link href={link} className="feed-card__media" aria-hidden>
          <div className="feed-card__placeholder">Haul report</div>
        </Link>
      )}
      <footer className="feed-card__actions">
        <ClaimBadges
          communityApproved={communityApproved}
          communityValidity={communityValidity}
          hasVideo={hasVideo}
        />
        {roiLabel && <span className="feed-card__stat feed-card__stat--highlight">{roiLabel}</span>}
        <Link href={link} className="feed-card__cta">
          View haul report
        </Link>
      </footer>
    </article>
  );
}
